export default {
  events: 'Events',
  loadingEvents: 'Loading events...',
  noUpcomingEvents: 'No upcoming events',
  updateEvents: 'Synchronize events',
  facebookLink: 'See the event on Facebook',
};
